import React from 'react';
import { Spin } from 'antd';
import { useTheme } from 'styled-components';
import Cube3DLoader from '@/components/ui/Cube3DLoader';

import { AppBody, InsideBodyScroll, InsideBodyScrollInner } from '@/components/layout/insideShell.styles';
import { insideIsDark } from '@utils/colorSystem';
import useUIStore from '@stores/ui.store';

export function InsideBody({ children, L }) {
    const theme = useTheme();
    const { bodyContainerRef, isChatRoute, isProjectKanbanLockPageScroll, bodyContentPadding, showProjectBodyLoader } = L;
    const p = bodyContentPadding;
    const overlayBg = insideIsDark(theme) ? 'rgba(20, 20, 20, 0.75)' : 'rgba(255, 255, 255, 0.78)';

    return (
        <AppBody>
            <InsideBodyScroll ref={bodyContainerRef} $lockHeight={isChatRoute || isProjectKanbanLockPageScroll}>
                <InsideBodyScrollInner
                    $pt={isChatRoute ? 0 : p.top}
                    $pr={isChatRoute ? 0 : p.right}
                    $pb={isChatRoute ? 0 : p.bottom}
                    $pl={isChatRoute ? 0 : p.left}
                    $kanbanLock={isChatRoute || isProjectKanbanLockPageScroll}
                >
                    {isChatRoute ? (
                        children
                    ) : isProjectKanbanLockPageScroll ? (
                        <div
                            style={{
                                boxSizing: 'border-box',
                                display: 'flex',
                                flexDirection: 'column',
                                flex: 1,
                                minHeight: 0,
                                overflow: 'hidden',
                            }}
                        >
                            {children}
                        </div>
                    ) : (
                        children
                    )}
                </InsideBodyScrollInner>
            </InsideBodyScroll>
            {showProjectBodyLoader ? (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: overlayBg,
                        pointerEvents: 'all',
                    }}
                    aria-busy="true"
                    aria-label="Loading project"
                >
                    <Cube3DLoader size={44} />
                </div>
            ) : null}
        </AppBody>
    );
}
